import { memo, useMemo } from "react";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";

import useStore from "store";

import CarInfoCard from "components/CarInfoCard";
import Filters from "components/Filters";
import InnerTextCard from "components/InnerTextCard";
import Text from "components/Text";

import messages from "../../../store/messages";

function Cars() {
  const { filters: { priceRangeFilter, carTypesFilter, fuelTypesFilter, gearboxFilter }, vehicles } = useStore();

  const Body = useMemo(() => styled.div`
    width:100%;
  `, []);

  const FlexContainer = useMemo(() => styled.div`
    margin-bottom: 50px;
    display: flex;
    flex-wrap: wrap;
    width:100%;
    gap: 20px;
    justify-content: flex-start;
    & > span{
      margin:0 auto;
    }
    & > div {
      width: 31.8%;
    }
    @media (min-width: 768px) and (max-width: 1280px) {
      & > div {
        width: 48%;
        max-height: 50vh;
      }
    }
    @media (max-width: 768px) {
      & > div {
        max-height: 30vh;
        width: 100%;
      }
    }
  `, []);

  const filteredVehicles = useMemo(() => (
    vehicles?.filter((item) => (item.category && carTypesFilter.length ? carTypesFilter.includes(item.category?.toLowerCase()) : item))
      ?.filter((item) => (item.transmission && gearboxFilter.length ? gearboxFilter.includes(item.transmission?.toLowerCase()) : item))
      ?.filter((item) => (item.fuelType && fuelTypesFilter.length ? fuelTypesFilter.includes(item.fuelType?.toLowerCase()) : item))
      ?.filter((item) =>
        (item.price + 1 && priceRangeFilter.length
          ? item.price > Number(priceRangeFilter[0]) && item.price < Number(priceRangeFilter[1])
          : item),
      )
  ), [carTypesFilter, fuelTypesFilter, gearboxFilter, priceRangeFilter, vehicles]);

  return (
    <Body>
      <Filters />
      <FlexContainer>
        {filteredVehicles.length ? filteredVehicles
          .map((vehicle) => (
            <InnerTextCard
              key={vehicle.id}
              photos={vehicle.photos.map(({ link }) => link)}
              title={vehicle.name}
              componentOnHover={(
                <CarInfoCard
                  fueltype={vehicle.fuelType}
                  gearbox={vehicle.transmission}
                  seats={4}
                />
              )}
            />
          )) : (
            <Text tag="span" variant="normal">
              <FormattedMessage {...messages.noCarsFound} />
            </Text>
        )}
      </FlexContainer>
    </Body>
  );
}
export default memo(Cars);
